import { licensedata } from "./table_typing"

export interface tableState {
    model:{
            license:licensedata[],
        }
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const tableInitialState = {
    model:{
        license: [] as licensedata[]
        }
        ,
        view:{
            loaded: false,
            autorefresh: false,
        }
    }


export function deepCopyTableThingyState(toCopy:tableState):tableState{
    return {
        model:{
            license:toCopy.model.license.map((license) =>
            {
                return {
                    ...license,
                }
            })
        },
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
    
}